import { render, staticRenderFns } from "./createPassword.vue?vue&type=template&id=4db20d2e&scoped=true"
import script from "./createPassword.vue?vue&type=script&lang=js"
export * from "./createPassword.vue?vue&type=script&lang=js"
import style0 from "./createPassword.vue?vue&type=style&index=0&id=4db20d2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db20d2e",
  null
  
)

export default component.exports